import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Configurator() {
  return <section className="relative py-32 overflow-hidden bg-[#252525]" data-id="element-37">
      {/* Steel texture pattern */}
      <div className="absolute inset-0 opacity-30" data-id="element-38">
        <div className="absolute inset-0 texture-steel" data-id="element-39" />
      </div>

      {/* Atmospheric gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#252525] via-transparent to-[#252525]" data-id="element-40" />
      <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-[#1A1A1A]/50 to-transparent" data-id="element-41" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-43">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-[#F5F3F0] mb-6" data-id="element-44">
            Visualize Your Style
          </h2>
          <p className="text-xl text-[#E8E4DF]/80 mb-10 font-light" data-id="element-45">
            Discover your architectural personality with our interactive design
            configurator. From rugged mountain lodge to refined modern, find the
            aesthetic that speaks to you.
          </p>

          <Link to="/style-quiz" className="inline-flex items-center gap-3 px-10 py-5 bg-[#A07656] text-white hover:bg-[#B8896A] transition-colors group" data-id="element-46">
            <span className="text-sm tracking-widest uppercase font-semibold" data-id="element-47">
              Start Style Quiz
            </span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-48" />
          </Link>
        </motion.div>
      </div>
    </section>;
}